/* =========================================================================
   Prototyp Onlineshop Solar – Produktdetailseite

   Sechs voneinander unabhängige Aufgaben. Jede prüft zuerst, ob ihre Elemente
   überhaupt da sind, und steigt sonst aus – die Produktseite baut sich aus
   Blöcken zusammen, und ein abgeschalteter Block darf die übrigen nicht
   mitreißen. Dieselbe Bauweise wie calculator.js.

   Die Fragezeichen-Erklärungen (.infotip) stehen bewusst NICHT hier, sondern in
   assets/overlay.js: dieselben Erklärungen stehen im Amortisationsrechner der
   Startseite, und product.js lädt dort nicht. Ein Aufklappmechanismus an zwei
   Stellen wären zwei Wahrheiten.

   Bewegungsreduktion braucht hier seit Stufe 4 einen Zweig, weil das Skript
   selbst scrollt: scrollIntoView({ behavior: 'smooth' }) fragt die
   CSS-Einstellung am Ende von base.css nicht. Alle übrigen Übergänge liegen im
   CSS und sind dort schon abgeschaltet.
   ========================================================================= */
(function () {
  function init() {
    const $ = (id) => document.getElementById(id);
    const ruhig = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
      : false;

    /* Einen Punkt in einem waagerecht scrollbaren Streifen ins Bild holen.
       Bewusst über scrollLeft und nicht über scrollIntoView: Letzteres kennt
       kein „nur waagerecht". Mit block: 'nearest' schiebt es zusätzlich die
       ganze Seite senkrecht, sobald der Streifen gerade nicht im Bild steht –
       und das ist bei der Sprungleiste der Normalfall, weil sie mobil nicht
       mehr klebt. Der Kunde säße dann beim Lesen im Sprung. */
    function haltenImBild(streifen, el) {
      if (!streifen || !el) return;
      const links = el.offsetLeft;
      const rechts = links + el.offsetWidth;
      if (links < streifen.scrollLeft) streifen.scrollLeft = links;
      else if (rechts > streifen.scrollLeft + streifen.clientWidth) {
        streifen.scrollLeft = rechts - streifen.clientWidth;
      }
    }

    /* ---------------------------------------------------------------------
       1. Galerie als Wischkarussell
       Der Bilderstreifen ist ein Scroll-Container mit Rastpunkten; das Wischen
       selbst macht der Browser. Dieses Skript führt nur nach, was dabei
       passiert – aktive Miniatur, Zähler und Quelle der Lupe. Die alte Fassung
       tauschte src und srcset an einem einzigen <img>; bliebe sie stehen,
       spränge das Bild bei jedem Wisch zurück.
       --------------------------------------------------------------------- */
    const track = $('galTrack');
    const slides = track ? Array.prototype.slice.call(track.querySelectorAll('.gallery__slide')) : [];
    const thumbStrip = document.querySelector('.gallery__thumbs');
    const thumbs = thumbStrip ? Array.prototype.slice.call(thumbStrip.querySelectorAll('.thumb')) : [];
    const lightbox = $('galLightbox');
    const lightboxImg = $('galLightboxImg');
    const zaehler = $('galCount');
    let aktiv = -1;

    /* Die Lupe zeigt danach GENAU das sichtbare Bild. Vorher wurde
       #galLightboxImg ausschliesslich beim Miniaturklick gesetzt – nach einem
       Wisch vergrösserte sie das zuletzt angetippte Bild, also ein anderes als
       das auf dem Schirm. */
    function setzen(i, mitStreifen) {
      if (i < 0 || i >= slides.length || i === aktiv) return;
      aktiv = i;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      thumbs.forEach(function (b, n) { b.classList.toggle('is-active', n === i); });
      if (zaehler) zaehler.textContent = (i + 1) + ' / ' + slides.length;
      if (lightboxImg) {
        const zoom = slides[i].getAttribute('data-zoom');
        const bild = slides[i].querySelector('img');
        if (zoom) lightboxImg.src = zoom;
        if (bild) lightboxImg.alt = bild.alt;
      }
      if (mitStreifen) haltenImBild(thumbStrip, thumbs[i]);
    }

    if (slides.length) {
      setzen(0, false);

      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          const i = parseInt(btn.getAttribute('data-index'), 10);
          if (isNaN(i) || !slides[i]) return;
          setzen(i, true);
          /* Mobil trägt der Rastpunkt-Streifen, ab 900 px die is-active-Logik.
             Unterschieden wird an der tatsächlichen Scrollbreite und nicht an
             einer zweiten, hier ausgeschriebenen 900 – die Schwelle steht im
             CSS, und zwei Zahlen wären zwei Wahrheiten. */
          if (track.scrollWidth > track.clientWidth) {
            slides[i].scrollIntoView({
              behavior: ruhig ? 'auto' : 'smooth',
              block: 'nearest',
              inline: 'center'
            });
          }
        });
      });

      if (slides.length > 1 && 'IntersectionObserver' in window) {
        /* Mehrere Schwellen und dann der sichtbarste Rastpunkt: mit einer
           einzigen Schwelle meldet beim Wischen auch der VERSCHWINDENDE seinen
           Durchgang, und je nach Rundung gewinnt der falsche. Im Ruhezustand
           liegt der eingerastete bei 1, jeder andere bei 0. */
        const io = new IntersectionObserver(function (entries) {
          let bester = null;
          entries.forEach(function (e) {
            if (!bester || e.intersectionRatio > bester.intersectionRatio) bester = e;
          });
          if (bester && bester.intersectionRatio >= 0.5) {
            setzen(slides.indexOf(bester.target), true);
          }
        }, { root: track, threshold: [0, 0.25, 0.5, 0.75, 1] });
        slides.forEach(function (s) { io.observe(s); });
      }
    }

    /* Sprung auf ein bestimmtes Bild von aussen – der Variantenwechsel
       (Aufgabe 4) zeigt damit das Foto der gewaehlten Variante. Gescrollt
       wird nur der Streifen selbst und nicht per scrollIntoView: das zoege
       auch die Seite mit, und wer an der Buybox die Variante umstellt,
       stuende ploetzlich oben an der Galerie. */
    function zeigeMedium(mediaId) {
      if (!mediaId || !slides.length) return;
      let i = -1;
      slides.forEach(function (s, n) { if (s.getAttribute('data-media-id') === String(mediaId)) i = n; });
      if (i < 0) return;
      setzen(i, true);
      if (track.scrollWidth > track.clientWidth) {
        const versatz = slides[i].getBoundingClientRect().left - track.getBoundingClientRect().left;
        track.scrollTo({ left: track.scrollLeft + versatz, behavior: ruhig ? 'auto' : 'smooth' });
      }
    }

    /* Lightbox. showModal() liefert Escape, Fokusfalle und Hintergrundsperre
       vom Browser; nachzubauen bleibt nur der Klick auf den Hintergrund –
       <dialog> meldet den als Klick auf sich selbst. */
    const zoomBtn = $('galZoom');
    if (zoomBtn && lightbox && typeof lightbox.showModal === 'function') {
      zoomBtn.addEventListener('click', function () { lightbox.showModal(); });
      const closeBtn = $('galClose');
      if (closeBtn) closeBtn.addEventListener('click', function () { lightbox.close(); });
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) lightbox.close();
      });
    } else if (zoomBtn) {
      /* Kein <dialog> im Browser: der Knopf würde ins Leere greifen. Lieber
         weg als tot – die Galerie funktioniert ohne ihn vollständig. */
      zoomBtn.hidden = true;
    }

    /* ---------------------------------------------------------------------
       2. Mitlaufende Kaufleiste
       Sie erscheint erst, wenn die Buybox nach OBEN aus dem Bild gelaufen
       ist. Die Abfrage auf `top < 0` ist der Grund: auf dem Telefon steht die
       Buybox beim Laden unterhalb des Bildschirms und ist damit ebenfalls
       „nicht sichtbar" – ohne die Richtungsprüfung klebte die Leiste dort von
       der ersten Sekunde an über der Seite.
       --------------------------------------------------------------------- */
    const buybox = $('buybox');
    const buybar = $('buybar');
    if (buybox && buybar && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          buybar.classList.toggle('is-visible', passed);
          buybar.setAttribute('aria-hidden', passed ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io.observe(buybox);
    }

    /* ---------------------------------------------------------------------
       3. Sprungleiste zu den Abschnitten
       Die Seite bleibt eine lange Seite, auf der alle Abschnitte offen
       untereinander stehen – mit Skript und ohne Skript gleich. Das ist die
       Grundstellung fuer jede Maschine ohne JavaScript und fuer Suchmaschinen,
       und sie soll es auch mit JavaScript bleiben.

       Das Skript verkuerzt nur den Weg dorthin: ein Klick springt zum
       Abschnitt, ein Beobachter markiert beim Scrollen den Punkt, bei dem der
       Kunde gerade liest. Ausgeblendet wird nichts. Eine frueher hier gebaute
       Reiterleiste tat genau das und liess einem Crawler von zehn
       H2-Abschnitten einen einzigen sichtbar – der gesparte Scrollweg war
       diesen Preis nicht wert. Was die Seite mobil kurz haelt, sind
       stattdessen die Aufklapper aus Aufgabe 6.

       Der obere Rand fuer die eigene Scrollkorrektur wird aus den Token
       gerechnet und nicht ausgeschrieben: mobil klebt seit Stufe 4 nur die
       Kopfzeile (--header-strip), ab 900 px kommt die Sprungleiste dazu
       (--pdpnav-h).
       --------------------------------------------------------------------- */
    const nav = $('pdpNav');
    let pdpTabZeigen = null;
    if (nav) {
      /* --pdpnav-h stand als fester Schaetzwert (52px) im CSS. Polsterung und
         Zeilenhoehe der Schrift ergeben real eine andere Zahl, dazu der 1px
         Rahmen des Streifens - beide Verbraucher dieses Tokens (die eigene
         Scrollkorrektur weiter unten UND scroll-margin-top in base.css)
         rechneten dadurch mit zu wenig Abstand. Gemessen statt geschaetzt
         behebt das an der Quelle, fuer beide gleichzeitig - auch wenn sich
         Polsterung oder Schriftgroesse spaeter aendern. Erneut gemessen,
         sobald Webfonts nachladen, weil sich die Zeilenhoehe mit der echten
         Schrift gegenueber der Fallback-Schrift verschieben kann. */
      const pdpnavHoeheSetzen = function () {
        document.documentElement.style.setProperty('--pdpnav-h', Math.ceil(nav.getBoundingClientRect().height) + 'px');
      };
      pdpnavHoeheSetzen();
      window.addEventListener('resize', pdpnavHoeheSetzen);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(pdpnavHoeheSetzen);

      const links = {};
      nav.querySelectorAll('a[href^="#"]').forEach(function (a) {
        links[a.getAttribute('href').slice(1)] = a;
      });
      const ids = Object.keys(links);
      const panels = {};
      ids.forEach(function (id) {
        const el = document.getElementById(id);
        if (el) panels[id] = el;
      });

      /* Rueckt den gewaehlten Abschnitt unter die Kopfzeile (und ab 900 px
         zusaetzlich unter die klebende Leiste), statt das selbst mit
         getBoundingClientRect()-Arithmetik nachzurechnen.

         Zwei eigene Anlaeufe dazu sind an dieser Stelle bereits gescheitert:
         parseInt() auf den rohen Custom-Property-String von --header-strip
         (ein calc()-Ausdruck) lieferte 0 statt der Kopfzeilenhoehe, und selbst
         mit gemessener Kopfzeilenhoehe blieb die Rechnung falsch, sobald
         Galerie und Kaufbox (beide sticky, im selben Grid) je nach
         Scrollstand unterschiedliche Werte fuer die "natuerliche" Position
         der Leiste ergaben. `scrollIntoView` ueberlaesst genau diese
         Kleinarbeit dem Browser selbst, der die Grid-/Sticky-Lage korrekt
         kennt - und `scroll-margin-top` auf .pdp-section[id] (base.css) legt
         bereits fest, wie viel Luft dabei zur Kopfzeile/Leiste bleibt. */
      const nachObenRuecken = function (panel) {
        /* html traegt global scroll-behavior: smooth (base.css) - das wuerde
           behavior:'auto' hier mitreissen und aus dem Sprung eine Animation
           machen, obwohl genau das an anderer Stelle in dieser Datei bereits
           unzuverlaessig war (ein selbst gebauter rAF-Lauf blieb in einem
           nicht sichtbaren/fokussierten Tab nach dem ersten Bild haengen).
           Kurz auf 'auto' umschalten erzwingt den sofortigen Sprung. */
        const html = document.documentElement;
        const vorherB = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';
        panel.scrollIntoView({ behavior: 'auto', block: 'start' });
        html.style.scrollBehavior = vorherB;
      };

      /* Markieren und Springen sind getrennt: ein Klick springt, das Scrollen
         markiert nur. Beide setzen denselben Zustand in der Leiste – der
         Klick quittiert sofort, der Beobachter weiter unten uebernimmt
         danach. Ein leeres id loescht die Markierung. */
      const markieren = function (id) {
        ids.forEach(function (k) {
          const aktiv = k === id;
          links[k].classList.toggle('is-active', aktiv);
          if (aktiv) links[k].setAttribute('aria-current', 'true');
          else links[k].removeAttribute('aria-current');
        });
        /* Der aktive Punkt steht immer im Bild – sonst zeigt eine waagerecht
           scrollbare Leiste dauerhaft die ersten drei Punkte, während der
           Kunde beim siebten liest. */
        if (links[id]) haltenImBild(nav, links[id]);
      };

      const zeigen = function (id, opts) {
        if (!links[id]) return;
        markieren(id);
        const panel = panels[id];
        if (!panel) return;
        /* Ein zugeklapptes Ziel wird beim Anspringen geoeffnet – sonst landet
           der Kunde auf einer blossen Ueberschrift und haelt den Abschnitt
           fuer leer. Mobil ist genau das der Normalfall (Aufgabe 6). */
        if (panel.tagName === 'DETAILS') panel.open = true;
        if (!opts || opts.scrollen !== false) nachObenRuecken(panel);
      };
      pdpTabZeigen = zeigen;

      /* Ein geteilter oder gebookmarkter Link auf einen Abschnitt
         (#pdp-downloads) springt dorthin und klappt ihn auf. Beim
         gewoehnlichen Laden ohne Hash passiert nichts: die Seite bleibt
         stehen, wo sie geladen wurde, und die Leiste behauptet noch keinen
         Abschnitt – der Kunde sieht zu diesem Zeitpunkt die Galerie. */
      if (ids.length) {
        const vonHash = window.location.hash ? window.location.hash.slice(1) : '';
        if (links[vonHash]) zeigen(vonHash);
      }

      /* Beim Scrollen markiert die Leiste den Abschnitt, bei dem der Kunde
         gerade liest. Der Beobachter spannt dafuer ein Band quer ueber das
         obere Viertel des Bildschirms: was dieses Band schneidet, gilt als
         gelesen; bei mehreren gewinnt der oberste in der Reihenfolge der
         Leiste. Das Band ist bewusst breit – ein schmales fiel mobil in die
         Luecken zwischen den zugeklappten Abschnitten, und die Leiste stand
         dann grundlos leer.

         Prozentwerte statt gemessener Pixel, weil --header-strip ein calc()
         ist und die Leiste ab 900 px zusaetzlich klebt – das Band liegt tief
         genug, dass beide Streifen darueber Platz haben.

         Schneidet kein Abschnitt das Band (ganz oben in der Galerie, ganz
         unten in der Fusszeile), wird die Markierung geloescht, statt eine
         falsche stehen zu lassen. Eine Sprungleiste ohne Scrollspy behauptet
         sonst nach 7000 px noch immer, der zuletzt geklickte Punkt sei der
         aktuelle. */
      if (ids.length && 'IntersectionObserver' in window) {
        const imBand = {};
        const spion = new IntersectionObserver(function (eintraege) {
          eintraege.forEach(function (e) { imBand[e.target.id] = e.isIntersecting; });
          let treffer = '';
          for (let i = 0; i < ids.length; i++) {
            if (imBand[ids[i]]) { treffer = ids[i]; break; }
          }
          markieren(treffer);
        }, { rootMargin: '-20% 0px -55% 0px', threshold: 0 });
        ids.forEach(function (id) { if (panels[id]) spion.observe(panels[id]); });
      }

      nav.addEventListener('click', function (e) {
        const a = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
        if (!a || !links[a.getAttribute('href').slice(1)]) return;
        /* Wie beim Warenkorbknopf (assets/cart.js): modifizierte Klicks und
           Klicks außerhalb der linken Maustaste wollen einen neuen Tab oder
           ein Kontextmenü, keinen abgefangenen Wechsel. */
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
        e.preventDefault();
        const id = a.getAttribute('href').slice(1);
        history.replaceState(null, '', '#' + id);
        zeigen(id);
      });
    }

    /* Links auf ein #pdp-*-Ziel ausserhalb der Sprungleiste – etwa der
       Ertragsrechner-Teaser in der Buybox – laufen ueber denselben Weg, statt
       dem nativen Browser-Sprung ueberlassen zu bleiben: der klappt ein mobil
       zugeklapptes Ziel nicht auf und markiert den Punkt in der Leiste
       nicht mit. */
    document.addEventListener('click', function (e) {
      if (!pdpTabZeigen) return;
      const a = e.target && e.target.closest ? e.target.closest('a[href^="#pdp-"]') : null;
      if (!a || (nav && nav.contains(a))) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      const zielId = a.getAttribute('href').slice(1);
      if (!document.getElementById(zielId)) return;
      e.preventDefault();
      history.replaceState(null, '', '#' + zielId);
      pdpTabZeigen(zielId);
    });

    /* ---------------------------------------------------------------------
       4. Variantenwechsel
       Vier Anzeigen hängen daran: der Preis in der Buybox, Preis und Name in
       der Kaufleiste und die Artikelnummer. Die Auswahl selbst trägt seit
       Stufe 4 name="id" auf den Radios – der Kauf trifft damit auch ohne
       JavaScript die richtige Variante, und dieses Skript ist reine Anzeige.

       Ereignisdelegation über den Behälter statt eines Zuhörers je Radio:
       change steigt auf, und ein Zuhörer ist einer statt dreier. Die Beträge
       kommen aus einem JSON-Block der Section, damit hier nichts formatiert
       werden muss: `money` kennt die Währungseinstellung des Shops, dieses
       Skript nicht.
       --------------------------------------------------------------------- */
    const wahl = $('variantChoice');
    const dataEl = $('pdpVariants');
    if (wahl && dataEl) {
      let variants = [];
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { variants = []; }
      if (variants.length) {
        wahl.addEventListener('change', function (e) {
          const feld = e.target;
          if (!feld || feld.name !== 'id') return;
          const chosen = variants.filter(function (v) { return String(v.id) === String(feld.value); })[0];
          if (!chosen) return;
          const price = $('pdpPrice');
          const barPrice = $('buybarPrice');
          const barVariant = $('buybarVariant');
          const barVariantName = $('buybarVariantName');
          const sku = $('pdpSku');
          if (price) price.textContent = chosen.price;
          if (barPrice) barPrice.textContent = chosen.price;
          /* buybarVariant traegt die ID und damit den Kauf ueber die Leiste,
             buybarVariantName nur deren Beschriftung. Beide muessen hier
             stehen: waere die ID vergessen worden, legte die Leiste stumm die
             falsche Variante in den Warenkorb – der teuerste denkbare Fehler
             dieser Seite, und er sieht nach nichts aus. */
          if (barVariant) barVariant.value = chosen.id;
          if (barVariantName && chosen.title) barVariantName.textContent = chosen.title;
          /* Hatte die vorher gewählte Variante eine Artikelnummer und die neue
             nicht, bliebe die alte stehen und beschriebe ab dann einen anderen
             Artikel. Deshalb wird geleert statt behalten. */
          if (sku) {
            if (chosen.sku) { sku.textContent = 'Art.-Nr. ' + chosen.sku; sku.hidden = false; }
            else { sku.textContent = ''; sku.hidden = true; }
          }
          /* Montagematerial-Zusatz im Lieferumfang: server-vorgerendertes
             Kachel-HTML je Variante aus custom.montage_zusatz (siehe
             sections/main-product.liquid, #pdpVariants). Leer bei "Ohne
             Montagematerial". */
          const lieferZusatz = $('pdpLieferumfangZusatz');
          if (lieferZusatz) lieferZusatz.innerHTML = chosen.montageZusatzHtml || '';
          /* Foto der Variante zeigen. Varianten ohne eigenes Bild (z. B. die
             Montagematerial-Auswahl) lassen die Galerie, wo sie ist. */
          zeigeMedium(chosen.mediaId);
          /* Modulleistung und Ertragsrechner auf die Variante umstellen
             (4 oder 8 Module). Die Felder werden gesetzt und dann per
             input-Ereignis angestossen – calculator.js rechnet auf input
             neu und zieht den Schieberegler nach, eine zweite Formel
             braucht es hier nicht. Varianten ohne eigene Leistung (z. B.
             Montagematerial) tragen den Produktwert und aendern nichts. */
          if (chosen.wp) {
            document.querySelectorAll('[data-wp-anzeige]').forEach(function (el) { el.textContent = chosen.wp + ' Wp'; });
            document.querySelectorAll('[data-wp-anzeige-zahl]').forEach(function (el) { el.textContent = chosen.wp; });
          }
          const rechnerSetzen = function (id, wert) {
            const feld = $(id);
            if (!feld || wert === null || wert === undefined || String(feld.value) === String(wert)) return;
            feld.value = wert;
            feld.dispatchEvent(new Event('input', { bubbles: true }));
          };
          if (chosen.wp) rechnerSetzen('in-kwp', Math.round(chosen.wp / 10) / 100);
          rechnerSetzen('in-cost', chosen.priceEuro);
        });
      }
    }

    /* ---------------------------------------------------------------------
       5. Technische Daten auf- und zuklappen
       Der Knopf richtet sich nach dem Zustand der Mehrheit: ist mindestens
       eine Gruppe zu, klappt er alle auf, sonst alle zu. Ein reiner Umschalter
       hätte nach einzelnen Klicks in den Gruppen das Gegenteil dessen getan,
       was seine Beschriftung ankündigt.
       --------------------------------------------------------------------- */
    const toggle = $('specsToggle');
    const groups = document.querySelectorAll('details.specs-acc');
    if (toggle && groups.length) {
      const sync = function () {
        let closed = 0;
        groups.forEach(function (d) { if (!d.open) closed++; });
        toggle.textContent = closed ? toggle.getAttribute('data-open') : toggle.getAttribute('data-close');
      };
      toggle.addEventListener('click', function () {
        let closed = 0;
        groups.forEach(function (d) { if (!d.open) closed++; });
        const openAll = closed > 0;
        groups.forEach(function (d) { d.open = openAll; });
        sync();
      });
      groups.forEach(function (d) { d.addEventListener('toggle', sync); });
      sync();
    }

    /* ---------------------------------------------------------------------
       6. Erklaerende Abschnitte mobil zuklappen, ab 900 px offen halten
       Die Bloecke dieser Seite summieren sich bei 390 px auf ueber 7400 px.
       Die Aufklapper darunter – Beschreibung, Lieferumfang, Hinweise,
       Herstellerangaben, Downloads – erklaeren und werden auf dem Weg zur
       Kaufentscheidung nicht gelesen; mobil steht deshalb nur ihre
       Ueberschrift da. Rechner, Zubehoer, Vorteile und Vertrauensblock sind
       keine Aufklapper und bleiben offen: sie verkaufen, sie erklaeren nicht.

       Das open-Attribut steht im Markup, und dieses Skript nimmt es MOBIL weg
       – nicht umgekehrt. Ein Attribut kann keine Bildschirmbreite kennen:
       waere die Grundstellung „zu", zeigte jede Maschine ohne JavaScript eine
       zugeklappte Schreibtischseite. So ist der Ausfall die alte,
       vollstaendig sichtbare Seite. Fuer einen Crawler bleibt der Text in
       beiden Faellen lesbar – ein zugeklapptes details behaelt seinen Inhalt
       im HTML, anders als das ausgeblendete Panel der frueheren Reiterleiste.

       Ab 900 px sind die Aufklapper blosse Ueberschriften: das CSS nimmt dem
       Summary den Mauszeiger (pointer-events: none), faengt damit aber nur
       den Klick ab – Enter/Leertaste auf dem fokussierten Summary loesen
       toggle trotzdem aus. Der Waechter holt das zugeklappte Panel sofort
       wieder auf, der Breitenwechsel ebenso.
       --------------------------------------------------------------------- */
    const folds = Array.prototype.slice.call(document.querySelectorAll('details.pdp-fold'));
    if (folds.length && window.matchMedia) {
      const gross = window.matchMedia('(min-width: 900px)');
      /* Ein per Hash angesprungener Abschnitt bleibt offen – ihn zuzuklappen
         waere das Gegenteil dessen, wonach der Link gefragt hat. */
      const ziel = window.location.hash ? window.location.hash.slice(1) : '';
      if (!gross.matches) {
        folds.forEach(function (d) { if (d.id !== ziel) d.open = false; });
        /* Der Sprung aus Aufgabe 3 lief vor diesem Zuklappen: die Abschnitte
           darueber sind seitdem kuerzer, das Ziel ist nach oben gerutscht.
           Einmal nachziehen. */
        if (ziel && pdpTabZeigen) pdpTabZeigen(ziel);
      }
      folds.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (gross.matches && !d.open) d.open = true;
        });
      });
      /* Wird das Fenster auf Schreibtischbreite gezogen, sperrt das CSS den
         Aufklapper wieder – dann muss offen stehen, was der Kunde mobil
         zugeklappt hat, sonst bleibt eine Ueberschrift ohne Bedienelement. */
      const aufDesktopOeffnen = function () {
        if (gross.matches) folds.forEach(function (d) { d.open = true; });
      };
      if (gross.addEventListener) gross.addEventListener('change', aufDesktopOeffnen);
      else if (gross.addListener) gross.addListener(aufDesktopOeffnen);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
